export const environment = {
  production: true,
  endpoint: 'https://api.skillsportfolio.com.au',
  logLevel: "silly",
  defaultCollectionLimit: 30,
  uploadMaxSize: 512000000,
  uploadMaxDuration: 30,
  uploadChunkSize: 20000000
}